<template>
  <div class="dashboard white-bg">
      <LayoutHeader :class="isShowSearch?'show dashboard-header':'dashboard-header'" />
      <LayoutSidebar/>
      <LayoutMain>
        <searchBanner style="margin-bottom:60px;"/>
        <!-- <designScence style="margin-bottom: 60px;"/> -->
        <designTemplate/>
        <LayoutFooter/>
      </LayoutMain>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref} from 'vue'
import LayoutHeader from '../components/layout/Header.vue'
import LayoutSidebar from '../components/layout/Sidebar.vue'
import LayoutMain from '../components/layout/Main.vue'
import searchBanner from '../components/module/searchBanner.vue'
import designScence from '../components/module/designScene.vue'
import designTemplate from '../components/module/designTemplate.vue'
import LayoutFooter from '../components/layout/Footer.vue'
export default defineComponent({
  name: 'Dashboard',
  components: {
    LayoutHeader, LayoutSidebar, LayoutMain, searchBanner, designTemplate, LayoutFooter
  },
  setup() {
    const isShowSearch = ref(false)
    const onScroll = (e: any) => {
      if (document.documentElement.scrollTop > 300) {
        isShowSearch.value = true
      }
      else {
        isShowSearch.value = false
      }
    }
    window.addEventListener('scroll', onScroll)
    return {
      isShowSearch
    }
  },
})

</script>